import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_mb-6 gfu-bt--b1" }
const _hoisted_2 = { class: "_grid _grid-cols-2 _grid-cols-3--m _gap-4 _gap-6--m _tac _jc-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_values_section_item = _resolveComponent("values-section-item")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.SectionValuesTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.Resources.PledgeManager.SectionValuesDescription), 1 /* TEXT */),
    _createVNode(_component_box, { huge: "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.values, (value) => {
            return (_openBlock(), _createBlock(_component_values_section_item, _mergeProps({
              key: value.valueID
            }, { ref_for: true }, value), null, 16 /* FULL_PROPS */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}